const ABOUT_IMG =
  "https://images.unsplash.com/photo-1605000797499-95a51c5269ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxvcmdhbmljJTIwZmFybWVyJTIwaGFydmVzdGluZyUyMHZlZ2V0YWJsZXMlMjBmaWVsZHxlbnwwfHx8fDE3OTE2NzYwNTh8MA&ixlib=rb-4.1.0&q=85";

const STATS = [
  { value: "100%", label: "Local" },
  { value: "0", label: "Waste Goal" },
  { value: "24h", label: "Farm-to-Table" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[#F9F6F0] pt-20 md:pt-32 pb-10 md:pb-14 px-4 sm:px-6 lg:px-12"
    >
      <div className="mx-auto max-w-7xl grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="rounded-[2rem] overflow-hidden shadow-2xl ring-1 ring-[#4A6B41]/10 aspect-[4/3]">
            <img
              src={ABOUT_IMG}
              alt="Farmer carrying a crate of fresh produce"
              className="h-full w-full object-cover"
            />
          </div>
          <div
            data-testid="about-stats"
            className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-[85%] grid grid-cols-3 rounded-2xl bg-[#4A6B41] text-[#F9F6F0] shadow-xl overflow-hidden"
          >
            {STATS.map((s, i) => (
              <div
                key={s.label}
                className={`px-3 py-5 text-center ${
                  i < STATS.length - 1 ? "border-r border-[#F9F6F0]/15" : ""
                }`}
              >
                <div className="font-serif text-2xl sm:text-3xl">{s.value}</div>
                <div className="mt-1 font-sans text-[11px] sm:text-xs uppercase tracking-wider text-[#F9F6F0]/80">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <span className="text-xs sm:text-sm font-sans uppercase tracking-[0.2em] font-bold text-[#4A6B41]">
            Our Mission
          </span>
          <h2 className="mt-3 font-sans font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#1C241B] tracking-tight">
            Bringing Communities Back to Their Roots
          </h2>
          <p className="mt-6 font-sans text-base sm:text-lg text-[#5A6757] leading-relaxed">
            Behind every local farm is a story of hard work, dedication, and
            pride. Behind every purchase is an opportunity to make a difference.
            At Source2Table, we believe the people who grow, raise, and produce
            our food deserve to be seen, valued, and supported. And we believe
            families deserve to know where their food comes from, who produces
            it, and the care that goes into it.
          </p>
          <p className="mt-4 font-sans text-base sm:text-lg text-[#5A6757] leading-relaxed">
            We're building more than a marketplace. We're bringing neighbours
            together, empowering local producers to thrive, and making it easier
            for communities to support the businesses that help sustain them.
            Because when you choose local, you're not just buying a product —
            you're supporting someone's livelihood, strengthening your community,
            and investing in a future worth growing. Source2Table — Know Your
            Source. Support Your Community.
          </p>
        </div>
      </div>

      <p
        data-testid="brand-tagline"
        className="s2t-fade-up mt-16 md:mt-20 text-center font-['Lobster'] text-[#4A6B41] text-5xl sm:text-6xl lg:text-7xl"
      >
        Where Fresh Starts
      </p>
    </section>
  );
};
